import { motion } from "framer-motion";
import { EASE, useSafeInView } from "@/components/Reveal";

const STEPS = [
  { label: "Source", example: "servicenow · ticket #4821" },
  { label: "Relationship", example: "linked → Q3 renewal decision" },
  { label: "Reasoning", example: "correlates w/ 3 deploy failures" },
  { label: "Recommendation", example: "escalate → account owner" },
];

export default function ProvenanceDiagram() {
  const [ref, show] = useSafeInView();
  return (
    <div ref={ref} className="min-w-[720px]">
      <svg viewBox="0 0 940 220" className="h-auto w-full" data-testid="diagram-provenance">
        {STEPS.map((s, i) => (
          <motion.g key={s.label}
            initial={{ opacity: 0, y: 14 }}
            animate={show ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, ease: EASE, delay: 0.2 + i * 0.22 }}
          >
            <rect x={i * 245} y="60" width="200" height="58" fill={i === 3 ? "rgba(0,192,200,0.08)" : "#0C0C0C"} stroke={i === 3 ? "#00C0C8" : "rgba(255,255,255,0.2)"} strokeOpacity={i === 3 ? 0.7 : 1} />
            <text x={i * 245 + 100} y="84" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="9.5" fontFamily="'JetBrains Mono', monospace" letterSpacing="2">
              {String(i + 1).padStart(2, "0")}
            </text>
            <text x={i * 245 + 100} y="104" textAnchor="middle" fill="#FFFFFF" fontSize="13.5" fontWeight="500" fontFamily="'Outfit', sans-serif">
              {s.label}
            </text>
            <text x={i * 245 + 100} y="146" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="10" fontFamily="'JetBrains Mono', monospace">
              {s.example}
            </text>
            {i < 3 && (
              <g>
                <line x1={i * 245 + 200} y1="89" x2={(i + 1) * 245} y2="89" stroke="rgba(255,255,255,0.35)" strokeWidth="1.1" />
                <path d={`M ${(i + 1) * 245 - 6} 84 L ${(i + 1) * 245} 89 L ${(i + 1) * 245 - 6} 94`} fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2" />
                <circle r="3" fill="#00C0C8">
                  <animateMotion dur="2.4s" begin={`${i * 0.7}s`} repeatCount="indefinite" path={`M ${i * 245 + 200} 89 L ${(i + 1) * 245} 89`} />
                </circle>
              </g>
            )}
          </motion.g>
        ))}

        <motion.g
          initial={{ opacity: 0 }}
          animate={show ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 1.4 }}
        >
          <text x="730" y="184" fill="rgba(255,255,255,0.4)" fontSize="10" fontFamily="'JetBrains Mono', monospace">confidence</text>
          <rect x="800" y="176" width="100" height="5" fill="rgba(255,255,255,0.1)" />
          <motion.rect x="800" y="176" height="5" fill="#00C0C8"
            initial={{ width: 0 }}
            animate={show ? { width: 87 } : {}}
            transition={{ duration: 1.1, ease: EASE, delay: 1.6 }} />
          <text x="906" y="183" fill="#00C0C8" fontSize="10" fontFamily="'JetBrains Mono', monospace">0.87</text>
        </motion.g>

        <motion.text x="40" y="196" fill="rgba(255,255,255,0.35)" fontSize="10" fontFamily="'JetBrains Mono', monospace" letterSpacing="2"
          initial={{ opacity: 0 }} animate={show ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 1.2 }}>
          EVERY RECOMMENDATION CARRIES ITS EVIDENCE CHAIN
        </motion.text>
      </svg>
    </div>
  );
}
